import { FormModel } from 'components/Form';
import { addonsType, discountType } from 'utils/constants/data';
import { Validators } from 'utils/validators';

export const AddEditDiscountForm = (strings: any, addOnCategories: any): FormModel[] => {
  const form: FormModel[] = [
    {
      label: strings.description,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'description',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: strings.booking_details_actual_revenue_category,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: '',
      field: 'addOnCategory',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      options: addOnCategories,
      isMulti: false,
      isClearable: true,
    },
    {
      label: strings.discountType,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'discountType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: discountType(strings),
    },
    {
      label: strings.price,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      placeholder: '',
      field: 'price',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt }],
      required: true,
      options: addonsType(strings),
      responsive: { xs: 12 },
    },
  ];

  return form;
};
